import { createReducer, on } from '@ngrx/store';
import { initialAufgabenFuerTabelleState } from './aufgabe-tabelle.state';
import * as schrittActions from './schritt.actions';

export const aufgabenFuerTabelleReducer = createReducer(
  initialAufgabenFuerTabelleState,

  on(schrittActions.loadMeineAufgabenSucceeded, (state, { aufgabenListe }) => {
    return {
      ...state,
      aufgabenFuerTabelleModels: aufgabenListe.aufgaben,
    };
  }),
  on(schrittActions.loadVertretungenAufgabenSucceeded, (state, { aufgabenListe }) => {
    return {
      ...state,
      aufgabenFuerTabelleModels: aufgabenListe.aufgaben,
      meineAufgabenFuerStartseiteTimeStamp: '0',
      meineAufgabenFuerStartseiteLoaded: false,
      meineAufgabenTimeStamp: '0',
      meineAufgabenLoaded: false,
    };
  }),
  on(
    schrittActions.loadMeineAufgabenSucceeded,
    (state, { aufgabenListe, aufgabenFuerStartseite }) => {
      if (aufgabenListe.aufgaben === null) {
        if (aufgabenFuerStartseite) {
          return { ...state, meineAufgabenFuerStartseiteLoaded: true };
        }

        return { ...state, meineAufgabenLoaded: true };
      }
      if (aufgabenFuerStartseite) {
        return {
          ...state,
          meineAufgabenFuerStartseiteTimeStamp: aufgabenListe.timestamp,
          meineAufgabenFuerStartseiteIds: aufgabenListe.aufgaben.map(a => a.aufgabe.aufgabenId),
          meineAufgabenFuerStartseiteLoaded: true,
        };
      } else {
        return {
          ...state,
          meineAufgabenTimeStamp: aufgabenListe.timestamp,
          meineAufgabenIds: aufgabenListe.aufgaben.map(a => a.aufgabe.aufgabenId),
          meineAufgabenLoaded: true,
        };
      }
    }
  )
);
